import { Component } from '@angular/core';
import { Status } from '@df/core/status';
import { BasketService } from '@df/session/api/basket/basket.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ActionComponent } from 'projects/app-default/src/app/ui/api/action.component';
@Component({
    selector: 'flush-basket-button',
    templateUrl: './flush-basket-button.html',
    standalone: true,
    imports: [ActionComponent, TranslationModule]
})
export class FlushBasketButtonComponent {
    constructor(private basketService: BasketService) {}
    protected status = new Status();
    protected onClick() {
        this.basketService.flush(this.status);
    }
}
